import { isEmpty, find, get } from 'lodash';
import tmsApi from './../../api/tmsApi';
import helper from './../helper';

const { createInputParam } = helper;

export default {
  namespaced: true,
  state: {
    dataState: {
      orders: 'LOADING',
      orderUnit: 'LOADING',
    },
    orders: [],
    get_routing: [],
    detailData: null,
    detailDataId: null,
    detailLoaded: false,
    dataLoaded: false,
    locations: null,
    selectedValue: {
      company: null,
      shipment: null,
    },
    count_info: {
      all: 0,
      unconfirmed: 0,
      confirmed: 0,
      cancelled: 0,
    },
    query: {
      search: '',
      company_id: null,
      customer_id: null,
      destination_id: null,
      page: {
        lastData: null,
        count: 10,
      },
      sort: {
        by: 'ID',
        direction: 'DESC',
      },
      skip: {
        by: 'ID',
      },
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.orders.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      if (!data.metadata) {
        data.metadata = {};
        data.metadata.time_in = '';
        data.metadata.time_out = '';
        data.metadata.driver_confirm = false;
      }
      if (typeof find(state.orders, { id: data.id }) !== 'object') {
        state.orders.push(data);
      }
    },
    REPLACE_DATA(state, orders) {
      state.orders.splice(0, state.orders.length, ...orders);
    },
    CLEAR_ORDER_DATA(state) {
      state.orders.splice(0);
    },
    ADD_ORDER_DATA_ON_LIST(state, data) {
      if (!data.metadata) {
        data.metadata = {};
      }
      state.orders.push(data);
    },
    ADD_ROUTING(state, data) {
      state.get_routing.push(data);
    },
    CLEAR_QUERY({ query }) {
      query.search = '';
      query.company_id = null;
      query.customer_id = null;
      query.destination_id = null;
      query.page.lastData = null;
      query.page.count = 10;
      query.sort.by = 'ID';
      query.sort.direction = 'DESC';
    },
    SET_COMPANY_ID(state, id) {
      state.query.company_id = id;
    },
    SET_CUSTOMER_ID(state, id) {
      state.query.customer_id = id;
    },
    SET_DESTINATION_ID(state, id) {
      state.query.destination_id = id;
    },
    SET_QUERY_SEARCH(state, search) {
      state.query.search = search;
    },
    SET_QUERY_PAGE(state, number) {
      state.query.page.number = number;
    },
    SET_QUERY_COUNT(state, count) {
      state.query.page.count = count;
    },
    SET_QUERY_SORT(state, sort) {
      const [by, direction] = sort.split('.');
      state.query.sort.direction = direction;
      state.query.sort.by = by;
    },
    SET_SKIP_BY(state, by) {
      state.query.skip.by = by;
    },
    SET_COUNT_INFO(state, info) {
      state.count_info.all = 0;
      info.forEach((c) => {
        state.count_info.all += c.count;
        if (c.status === 'UNCONFIRMED') {
          state.count_info.unconfirmed += c.count;
        } else if (c.status === 'CONFIRMED') {
          state.count_info.confirmed += c.count;
        } else if (c.status === 'CANCELLED') {
          state.count_info.cancelled += c.count;
        }
      }, this);
    },
    SET_DETAIL_NOT_LOADED(state) {
      state.detailLoaded = false;
    },
    SET_DETAIL_LOADED(state) {
      state.detailLoaded = true;
    },
    SET_DETAIL_ID(state, id) {
      state.detailDataId = id;
    },
    SET_DETAIL_DATA(state, data) {
      if (!data.metadata) {
        data.metadata = {};
        data.metadata.time_in = '';
        data.metadata.time_out = '';
        data.metadata.driver_confirm = false;
      }
      state.detailData = data;
    },
    SET_QUERY_LAST_DATA({ query }, data) {
      query.page.lastData = data;
    },
    SET_LOCATION_DATA(state, data) {
      state.locations = data;
    },
    DELETE_DETAIL_DATA(state, id) {
      const index = state.orders.findIndex(order => order.id === id);
      state.orders.splice(index, 1);
    },
    CLEAR_SELECTED_VALUE(state) {
      state.selectedValue.company = null;
      state.selectedValue.shipment = null;
    },
    SET_SELECTED_VALUE(state, data) {
      const { company, shipment } = data;
      state.selectedValue.company = company;
      state.selectedValue.shipment = shipment;
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
    SET_DATA_LOADED(state) {
      state.dataLoaded = true;
    },
    SET_DATA_NOT_LOADED(state) {
      state.dataLoaded = false;
    },
    SET_DATA_STATE_ORDERS({ dataState }, state) {
      dataState.orders = state;
    },
    SET_DATA_STATE_ORDER_UNIT({ dataState }, state) {
      dataState.orderUnit = state;
    },
  },
  getters: {
    get_order_route(state) {
      return state.get_routing || [];
    },
    orders(state) {
      return state.orders;
    },
    count_all(state) {
      return state.count_info.all;
    },
    count_unconfirmed(state) {
      return state.count_info.unconfirmed;
    },
    count_confirmed(state) {
      return state.count_info.confirmed;
    },
    count_cancelled(state) {
      return state.count_info.cancelled;
    },
    get_detail_data(state) {
      return state.detailData || {
        confirmations: [],
      };
    },
    get_locations_data(state) {
      return state.locations || [];
    },
    detailLoaded(state) {
      return state.detailLoaded;
    },
    get_selected_value(state) {
      return state.selectedValue;
    },
    dataLoaded(state) {
      return state.dataLoaded;
    },
    dataOrderUnit(state) {
      return state.dataState.orderUnit;
    },
    dataOrders(state) {
      return state.dataState.orders;
    },
  },
  actions: {
    LOAD_DATA({ state, commit, rootState }, payloads = {}) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { count, lastData } = state.query.page;
      const { by, direction } = state.query.sort;
      const { by: skipBy } = state.query.skip;
      const limit = count;
      const companyId = createInputParam(state.query, 'company_id', false);
      const customerId = createInputParam(state.query, 'customer_id', false);
      const destinationId = createInputParam(state.query, 'destination_id', false);
      let after = '';
      let before = '';
      if (direction === 'ASC') {
        after = `after: "${lastData}"`;
      } else {
        before = `before: "${lastData}"`;
      }
      let skip = '';
      if (lastData !== null) {
        skip = `
          skip: {
            by: ${skipBy}
            ${after}
            ${before}
          },
        `;
      }

      const { start_date = null, end_date = null, assigned = null } = payloads;
      const startDateQuery = start_date ? `start_date: "${start_date}"` : '';
      const endDateQuery = end_date ? `end_date: "${end_date}"` : '';
      const assignedStatus = assigned !== null ? `assigned: ${assigned}` : '';

      const query = `
        {
          orders(
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${skip}
            ${companyId}
            ${customerId}
            ${destinationId}
            ${startDateQuery}
            ${endDateQuery}
            ${assignedStatus}
          ) {
            id
            number
            sequence
            metadata
            status
            created_at
            updated_at
            delivery_date
            type
            company {
              id
              name
            }
            destination {
              id
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
              metadata
            }
            shipment {
              id
              number
            }
            customer {
              id
              external_id
              name
              address {
                city
                state
                country
                zip_code
                address1
                address2
              }
            }
            confirmations {
              key
              name
              signature
              created_at
              metadata
            }
            units {
              number
              type
            }
          }
        }
      `;
      commit('SET_DATA_STATE_ORDERS', 'LOADING');
      return api(query, 'orders').then(({ data }) => {
        const { orders } = data;
        commit('REPLACE_DATA', orders);
      }).then(() => {
        commit('SET_DATA_STATE_ORDERS', 'LOADED');
      }).catch(() => {
        commit('SET_DATA_STATE_ORDERS', 'ERROR');
      });
    },
    LOAD_INFO({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const query = `
        {
          order_info(query: "${state.query.search}") {
            count
            status
          }
        }
      `;
      commit('CLEAR_DATA');
      return api(query, 'load_info').then(({ data }) => {
        const { order_info } = data;
        commit('SET_COUNT_INFO', order_info);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_INFO');
      });
    },
    LOAD_ORDER_ROUTE({ commit, rootState }) {
      const api = tmsApi.build(rootState.token, 'shipment_md');
      const query = '';
      commit('CLEAR_DATA');
      return api(query, 'create_shipment_by_order_route').then(({ data }) => {
        commit('ADD_ROUTING', data.get_routing);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_ORDER_ROUTE');
      });
    },
    FIND_DATA({ state, commit, rootState }) {
      const api = tmsApi.build(rootState.token, 'shipment_md');
      const { count, lastData } = state.query.page;
      const { by, direction } = state.query.sort;
      const { by: skipBy } = state.query.skip;
      const limit = count;
      const companyId = state.query.company_id === null
        ? '' : `company_id: ${state.query.company_id}`;
      let after = '';
      let before = '';
      if (direction === 'ASC') {
        after = `after: "${lastData}"`;
      } else {
        before = `before: "${lastData}"`;
      }
      let skip = '';
      if (lastData !== null) {
        skip = `
          skip: {
            by: ${skipBy}
            ${after}
            ${before}
          },
        `;
      }
      const query = `
        {
          orders: find_orders(
            query: "${state.query.search}",
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${skip}
            ${companyId}
          ) {
            id
            number
            sequence
            metadata
            created_at
            updated_at
            company {
              id
              name
            }
            destination {
              id
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
              metadata
            }
            shipment {
              id
              number
            }
            customer {
              external_id
              name
              address {
                city
                state
                country
                zip_code
                address1
                address2
              }
            }
            confirmations {
              key
              name
              signature
              created_at
              metadata
            }
          }
        }
      `;
      commit('CLEAR_DATA');
      commit('SET_DATA_NOT_LOADED');
      return api(query, 'find_orders').then(({ data }) => {
        const { orders } = data;
        orders.forEach((order) => {
          commit('ADD_DATA_ON_LIST', order);
        }, this);
      }).then(() => {
        setTimeout(() => commit('SET_DATA_LOADED'), 1e3);
      }).catch(() => {
        commit('ADD_ERROR', 'FIND_DATA');
      });
    },
    LOAD_DETAIL_DATA({ state, commit, rootState }) {
      const api = tmsApi.build(rootState.token, 'shipment_md');
      const query = `
        {
          order(id: ${state.detailDataId}) {
            id
            number
            sequence
            metadata
            status
            created_at
            updated_at
            customer {
              id
              external_id
              name
              address {
                city
                state
                country
                zip_code
                address1
                address2
              }
            }
            invoice {
              id
              number
            }
            destination {
              id
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
              metadata
              company {
                id
                name
              }
            }
            company {
              id
              name
            }
            units {
              id
              number
              type
            }
            shipment {
              id
              number
            }
            confirmations {
              key
              name
              created_at
              signature
              metadata
            }
          }
        }
      `;
      // commit('SET_DETAIL_NOT_LOADED');
      commit('SET_DATA_STATE_ORDERS', 'LOADING');
      commit('SET_DATA_STATE_ORDER_UNIT', 'LOADING');
      return api(query, 'order').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.order);
        // commit('SET_DETAIL_LOADED');
        commit('SET_DATA_STATE_ORDERS', 'LOADED');
        commit('SET_DATA_STATE_ORDER_UNIT', 'LOADED');
      }).catch(() => {
        commit('SET_DATA_STATE_ORDERS', 'ERROR');
        commit('SET_DATA_STATE_ORDER_UNIT', 'ERROR');
      });
    },
    LOAD_LOCATIONS({ commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const query = `
        {
          locations {
            id
            code
            name
            type
            company {
              id
              name
            }
          }
        }
      `;
      return api(query, 'locations').then(({ data }) => {
        commit('SET_LOCATION_DATA', data.locations);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_LOCATIONS');
      });
    },
    UPDATE_DATA({ state, commit, rootState }, payloads) {
      let { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');

      const {
        destination, company, invoice, shipment, units, delivery_date, type, metadata, customer,
      } = payloads;

      if (Object.prototype.hasOwnProperty.call(payloads, 'id')) {
        detailDataId = payloads.id;
      }

      const metadataUpdate = metadata || {};

      const variables = {
        id: detailDataId,
        input: {
          update_meta: metadataUpdate,
        },
      };

      if (!isEmpty(payloads.number)) {
        variables.input.number = payloads.number;
      }

      if (!isEmpty(units)) {
        variables.input.units = units;
      }

      if (!isEmpty(invoice)) {
        variables.input.invoice_id = invoice.id;
      }
      if (!isEmpty(company)) {
        variables.input.company_id = company.id;
      }
      if (!isEmpty(shipment)) {
        variables.input.shipment_id = shipment.id;
      }
      if (!isEmpty(destination)) {
        variables.input.destination_id = destination.id;
      }
      if (!isEmpty(delivery_date)) {
        variables.input.delivery_date = delivery_date;
      }
      if (!isEmpty(type)) {
        variables.input.type = type;
      }
      if (!isEmpty(customer)) {
        variables.input.customer_id = customer.id;
      }

      const query = `
        mutation CreateUpdateOrder($id: ID!, $input: OrderUpdateInput) {
          order: update_order(id: $id, input: $input) {
            id
            number
            sequence
            metadata
            created_at
            updated_at
            customer {
              external_id
              name
              address {
                city
                state
                country
                zip_code
                address1
                address2
              }
            }
            invoice {
              id
              number
            }
            destination {
              id
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
            }
            company {
              id
              name
            }
            units {
              id
              number
              type
            }
            shipment {
              id
              number
            }
          }
        }
      `;

      return api({
        query,
        variables,
      }, 'update_order').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.order);
      }).catch(() => {
        commit('ADD_ERROR', 'UPDATE_DATA');
      });
    },
    CREATE_DATA({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const {
        customer, company, destination, invoice, shipment, units: orderUnits, metadata,
        delivery_date, type,
      } = payloads;

      const variables = {
        input: {
          number: payloads.number,
          company_id: company.id,
          customer_id: customer.id,
          destination_id: destination.id,
        },
      };

      if (shipment) {
        variables.input.shipment_id = shipment.id;
      }
      if (invoice) {
        variables.input.invoice_id = invoice.id;
      }
      if (orderUnits) {
        variables.input.units = orderUnits;
      }
      if (metadata) {
        variables.input.metadata = metadata;
      }
      if (delivery_date) {
        variables.input.delivery_date = delivery_date;
      }
      if (type) {
        variables.input.type = type;
      }

      const query = `
        mutation CreateUpdateOrder($input: OrderCreateInput) {
          order: create_order(input: $input) {
            id
            number
            sequence
            metadata
            created_at
            updated_at
            delivery_date
            customer {
              id
              external_id
              name
              address {
                city
                state
                country
                zip_code
                address1
                address2
              }
            }
            invoice {
              id
              number
            }
            destination {
              id
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
            }
            company {
              id
              name
            }
            units {
              id
              number
              type
            }
            shipment {
              id
              number
            }
          }
        }
      `;

      return api({
        query,
        variables,
      }, 'create_order').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.order);
        return data.order;
      }).catch(() => {
        commit('ADD_ERROR', 'CREATE_DATA');
      });
    },
    DELETE_DATA({ state, commit, rootState }, orderId) {
      const id = !orderId ? state.detailDataId : orderId;
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');

      const mutation = `mutation {
        deleted: delete_order(id: ${id})
      }`;

      return api(mutation, 'delete_order').then(({ data }) => {
        const deleteOk = data.deleted;
        if (deleteOk) commit('DELETE_DETAIL_DATA', id);
        return deleteOk;
      }).catch(() => {
        commit('ADD_ERROR', 'DELETE_DATA');
      });
    },
    DELETE_DATA_BY_SHIPMENT({ rootState, commit }, shipmentId) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');

      const mutation = `mutation {
        deleted: delete_orders_by_shipment(shipment_id: ${shipmentId})
      }`;

      return api(mutation, 'delete_orders').then(({ data }) => data.deleted).catch(() => {
        commit('ADD_ERROR', 'DELETE_DATA_BY_SHIPMENT');
      });
    },
    CREATE_UNIT({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const orderId = isEmpty(payloads.orderId) ? '' : `order_id: ${payloads.orderId}`;
      const number = createInputParam(payloads, 'number');
      const type = createInputParam(payloads, 'type');

      const mutation = `mutation {
        unit: create_unit(input: {
          ${number}
          ${type}
          ${orderId}
        }) {
          id
          number
          type
        }
      }`;

      return api(mutation, 'create_unit').then(({ data }) => {
        const { unit } = data;
        return unit;
      }).catch(() => {
        commit('ADD_ERROR', 'CREATE_UNIT');
      });
    },
    LOAD_DAILY_ORDERS({ rootState, commit }, payloads) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { start_date, end_date } = payloads;
      const query = `{
        daily_orders(
          start_date: "${start_date}"
          end_date: "${end_date}"
        ) {
          date
          count
          percentage
        }
      }`;
      return api(query, 'daily_orders').then(({ data }) => data.daily_orders).catch(() => {
        commit('ADD_ERROR', 'LOAD_DAILY_ORDERS');
      });
    },
    LOAD_ORDERS_BY_RANGE_DATE({ rootState, commit }, payloads) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { start_date, end_date } = payloads;

      const query = `
      {
        orders(
          start_date: "${start_date}"
          end_date: "${end_date}"
        ) {
            id
            number
            sequence
            metadata
            status
            created_at
            updated_at
            company {
              id
              name
            }
            destination {
              id
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
              metadata
            }
            shipment {
              id
              number
            }
            customer {
              id
              external_id
              name
              address {
                city
                state
                country
                zip_code
                address1
                address2
              }
            }
            confirmations {
              key
              name
              signature
              created_at
              metadata
            }
            units {
              number
              type
            }
        }
      }`;

      return api(query, 'load_orders_by_range_date')
        .then(({ data }) => data.orders)
        .catch(() => {
          commit('ADD_ERROR', 'LOAD_ORDERS_BY_RANGE_DATE');
        });
    },
    LOAD_JOBS({ rootState, commit }, payload) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { start_date: startDate, end_date: endDate } = payload;
      const query = `
      {
        jobs(
          start_date: "${startDate}"
          end_date: "${endDate}"
        ) {
            type
            count
            orders {
              id
              number
              metadata
              status
              created_at
              confirmations {
                id
                type
                key
                created_at
              }
              destination {
                name
                latitude
                longitude
                metadata
              }
              shipment {
                id
              }
            }
        }
      }`;
      return api(query, 'jobs')
        .then(({ data }) => data.jobs)
        .catch(() => {
          commit('ADD_ERROR', 'LOAD_JOBS');
        });
    },
    LOAD_JOBS_INFO({ rootState, commit }, payload) {
      const api = tmsApi.build(rootState.token, 'shipment_md');
      const { start_date: startDate, end_date: endDate } = payload;
      const query = `
      {
        jobs(
          start_date: "${startDate}"
          end_date: "${endDate}"
        ) {
          type
          count
        }
      }`;
      return api(query, 'jobs_info')
        .then(({ data }) => data.jobs)
        .catch(() => {
          commit('ADD_ERROR', 'LOAD_JOBS');
        });
    },
    LOAD_JOB_HISTORY({ rootState }, jobId) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const query = `
        {
          order(id: ${jobId}) {
            id
            history {
              type
              updated_at
              action_by {
                full_name
                username
              }
              before
              after
              metadata
            }
          }
        }
      `;
      return api(query, 'order_history')
        .then(({ data }) => data.order.history);
    },
    LOAD_JOBS2({ rootState, commit }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const query = `
      {
        jobs2 {
            type
            count
            orders {
              id
              number
              type
              metadata
              status
              destination {
                id
                code
                name
                latitude
                longitude
                geometry {
                  type
                  coordinates
                }
                metadata
              }
              shipment {
                id
                number
                delivery_date
                metadata
                type
                driver {
                  id
                  name
                }
                vehicle {
                  id
                  reg_no
                  driver {
                    name
                  }
                }
                state
              }
              customer {
                id
                external_id
                name
                address {
                  city
                  state
                  country
                  zip_code
                  address1
                  address2
                }
              }
              confirmations {
                key
                name
                signature
                created_at
                metadata
              }
            }
        }
      }`;
      return api(query, 'jobs2')
        .then(({ data }) => data.jobs2)
        .catch(() => {
          commit('ADD_ERROR', 'LOAD_JOBS2');
        });
    },
    ASSIGN_VEHICLE_JOB({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const {
        order_id: orderId,
        vehicle_id: vehicleId,
        type,
        customer_id: customerId,
        destination_id: destinationId,
      } = payloads;
      let customer = '';
      let destination = '';

      if (customerId) {
        customer = `customer_id: ${customerId}`;
      }
      if (destinationId) {
        destination = `destination_id: ${destinationId}`;
      }

      const mutation = `mutation {
        assigned: assign_vehicle_job(id: ${orderId}, input: {
          vehicle_id: ${vehicleId},
          type: ${type}
          ${customer}
          ${destination}
        })
      }`;

      return api(mutation, 'assign_vehicle_job').then(({ data }) => {
        const { assigned } = data;
        return assigned;
      }).catch(() => {
        commit('ADD_ERROR', 'FINISH_ORDER');
      });
    },
    FINISH_ORDER({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const { order_id: orderId, reason } = payloads;

      const mutation = `mutation {
        confirmed: set_confirmed_order(id: ${orderId}, input: {
          notes: "${reason}"
        })
      }`;

      return api(mutation, 'set_confirmed_order').then(({ data }) => {
        const { confirmed } = data;
        return confirmed;
      }).catch(() => {
        commit('ADD_ERROR', 'FINISH_ORDER');
      });
    },
    REMOVE_METADATA_KEY({ state, commit, rootState }, payloads) {
      let { detailDataId } = state;
      const { key } = payloads;
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');

      if (Object.prototype.hasOwnProperty.call(payloads, 'id')) {
        detailDataId = payloads.id;
      }

      const variables = {
        id: detailDataId,
        input: {
          key,
        },
      };

      const query = `
        mutation RemoveMetadataKey($id: ID!, $input: OrderRemoveMetadataKeyInput) {
          order: remove_metadata_key(id: $id, input: $input) {
            id
          }
        }
      `;

      return api({
        query,
        variables,
      }, 'remove_metadata_key').catch(() => {
        commit('ADD_ERROR', 'REMOVE_METADATA_KEY');
      });
    },
    LOAD_JOBS2_INFO({ rootState, commit }, payload) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const startDate = get(payload, 'start_date', '');
      const endDate = get(payload, 'end_date', '');

      let startDateStr = '';
      let endDateStr = '';
      let parameters = '';

      if (startDate) {
        startDateStr = `start_date: "${startDate}"`;
      }
      if (endDate) {
        endDateStr = `end_date: "${endDate}"`;
      }

      if (startDate && endDate) {
        parameters = `(${startDateStr} ${endDateStr})`;
      }

      const query = `
      {
        jobs2 ${parameters} {
          type
          count
        }
      }`;
      return api(query, 'jobs2_info')
        .then(({ data }) => data.jobs2)
        .catch(() => {
          commit('ADD_ERROR', 'LOAD_JOBS2_INFO');
        });
    },
    LOAD_CONFIRMATION_ORDER_HISTORY({ rootState, commit }, jobId) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const query = `
      {
        history: confirmation_history_by_order_id (order_id: ${jobId}) {
          type
          updated_at
          action_by {
            full_name
            username
          }
          before
          after
          metadata
        }
      }`;
      return api(query, 'confirmation_history_by_order_id')
        .then(({ data }) => data.history)
        .catch(() => {
          commit('ADD_ERROR', 'LOAD_CONFIRMATION_ORDER_HISTORY');
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/shipment_md/orders.js